import { format, parseISO, differenceInDays, isWithinInterval } from 'date-fns';

/**
 * Get color scheme for reservation status
 */
export const getStatusColor = (status: string): { bg: string; border: string; text: string } => {
    switch (status.toLowerCase()) {
        case 'confirmed':
            return { bg: '#d4edda', border: '#28a745', text: '#155724' };
        case 'pending':
            return { bg: '#fff3cd', border: '#ffc107', text: '#856404' };
        case 'cancelled':
            return { bg: '#f8d7da', border: '#dc3545', text: '#721c24' };
        default:
            return { bg: '#e2e3e5', border: '#6c757d', text: '#383d41' };
    }
};

/**
 * Format date for display
 */
export const formatDate = (dateString: string, formatStr: string = 'MMM dd, yyyy'): string => {
    try {
        return format(parseISO(dateString), formatStr);
    } catch {
        return dateString;
    }
};

/**
 * Calculate number of nights
 */
export const calculateNights = (checkIn: string, checkOut: string): number => {
    try {
        return differenceInDays(parseISO(checkOut), parseISO(checkIn));
    } catch {
        return 0;
    }
};

/**
 * Check if reservation overlaps with date range
 */
export const overlapsDateRange = (
    reservation: { check_in_date: string; check_out_date: string },
    start: Date,
    end: Date
): boolean => {
    try {
        const checkIn = parseISO(reservation.check_in_date);
        const checkOut = parseISO(reservation.check_out_date);

        return (
            isWithinInterval(checkIn, { start, end }) ||
            isWithinInterval(checkOut, { start, end }) ||
            (checkIn <= start && checkOut >= end)
        );
    } catch {
        return false;
    }
};

/**
 * Get status badge variant for Bootstrap
 */
export const getStatusBadgeVariant = (status: string): string => {
    switch (status.toLowerCase()) {
        case 'confirmed':
            return 'success';
        case 'pending':
            return 'warning';
        case 'cancelled':
            return 'danger';
        default:
            return 'secondary';
    }
};